/**
 * Format a date string to a human-readable format.
 * @param dateString - ISO date string or null
 * @returns Formatted date string or 'N/A' if invalid
 */
export const formatDateTime = (dateString: string | null | undefined): string => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return 'N/A';
  }
};

 /**
* Add empty option to a select component.
* @returns { value: string | number; label: string }.
*/
export const addEmptyOption = (
    options: { value: string | number; label: string }[]
  ) => {
    return [{ value: "", label: "--Select--" }, ...options];
  };

  /**
 * Get the singular of a word.
 *
 * @param   word  string of a plural.
 * @returns singular string.
 * @example 
 *  const result = getSingular("Providers");
     console.log(result); // Provider
    result = getSingular("Companies");
     console.log(result); // Company
 */
  export const getSingular = (word:string) => {
    if (word.endsWith("ies")) {
      return word.slice(0, -3) + "y";
    }
    if (/(sses|shes|ches|xes|zes)$/i.test(word)) {
      return word.slice(0, -2);
    }
    if (word.endsWith("s")) {
      return word.slice(0, -1);
    }
    return word;
  };
  export const applySingularToPath = (path: string) => {
    return path
        .split('/')
        .map((segment, index) => {
            // Apply singularization only to non-dynamic segments (e.g., "mission-requests" to "mission-request")
            if (!segment.match(/^\d+$/)) {
                return getSingular(segment); // Apply singularization to regular path segments
            }
            return segment; // Leave dynamic segments (like "66") unchanged
        })
        .join('/');
};

  export const formatFullAddress = (
    countryName?: string,
    stateName?: string,
    cityName?: string,
    address?: string | null
  ): string => {
    const parts: string[] = [];
    
    if (countryName) {
      parts.push(countryName);
    }
  
    if (stateName) {
      parts.push(stateName);
    }
    
    if (cityName) {
      parts.push(cityName);
    }
    
    if (address) {
      parts.push(address);
    }
    
    return parts.join(', ');
  };
  
  // Function that accepts an address entity object and formats the address
  export const formatAddress = (addressEntity: any): string => {
    return formatFullAddress(
      addressEntity.country?.name,
      addressEntity.state?.name,
      addressEntity.city?.name,
      addressEntity.address
    );
  };


  export const toDatetimeLocalString = (dateStr: string | null): string | undefined => {
    if (!dateStr) return undefined;
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return undefined;
    return date.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
  }
  export const toLocalDateTimeString = (date: string | number | Date): string | undefined => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return undefined; // invalid date
  
    const pad = (n: number) => n.toString().padStart(2, "0");
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
  
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };